import { keyframes } from 'styled-components';

export const INITIAL_OFFSET = '0';
export const OUT_OFFSET = '-14px';
export const IN_OFFSET = '38px';
export const FINAL_OFFSET = '26px';

export const INITIAL_SCALE = '1';
export const FINAL_SCALE = '0.7';

export const KEY_WITH_SCALE = keyframes`
  0% {
    opacity: 1;
    transform: translateY(${INITIAL_OFFSET}) scale(${INITIAL_SCALE});
  } 40% {
    opacity: 0;
    transform: translateY(${OUT_OFFSET}) scale(${INITIAL_SCALE});
  } 60% {
    opacity: 0;
    transform: translateY(${IN_OFFSET}) scale(${FINAL_SCALE});
  } 100% {
    opacity: 1;
    transform: translateY(${FINAL_OFFSET}) scale(${FINAL_SCALE});
  }
`;

export const KEY_NO_SCALE = keyframes`
  0% {
    opacity: 1;
    transform: translateY(${INITIAL_OFFSET});
  } 40% {
    opacity: 0;
    transform: translateY(${OUT_OFFSET});
  } 60% {
    opacity: 0;
    transform: translateY(${IN_OFFSET});
  } 100% {
    opacity: 1;
    transform: translateY(${FINAL_OFFSET});
  }
`;
